<form
  class="reflect-settings related-content-group sub-content related-items-container-skin"
  novalidate
  #reflectorForm="ngForm"
>
  <div class="container">
    <div class="modal-header">
      <div class="reflector-header">
        <span class="header"><b>Endpoint </b> {{ deviceName }}</span>
        <i class="mdi mdi-close close-icon" mat-dialog-close></i>
      </div>
    </div>
    <div class="content">
      <div class="row">
        <div class="tabsContainer" [ngClass]="{ extwidth: activeTestlist.length > 16 }">
          <div class="btn-group-vertical">
            <button
              mat-button
              class="conn-list-btn btn btn-small"
              title="Create new reflector test"
              [ngClass]="{ newtestActive: isNewTestConfig == true && !activeTabID }"
              [disabled]="actionMsg || errorMsg"
              (click)="createNewInstance()"
            >
              <mat-icon class="material-icons mat-18">add</mat-icon> Reflector
            </button>
            <div class="instance-menu" *ngFor="let instance of activeTestlist">
              <button
                mat-button
                class="conn-list-btn btn btn-small conn-1"
                (click)="selectedInstance(instance, false)"
                *ngIf="instance.instanceName"
                title="{{ instance.instanceName }}"
                [disabled]="actionMsg || errorMsg"
                [ngClass]="{ active: instance.id === activeTabID }"
              >
                <span class="dot-badge" [ngClass]="instance.status"></span>
                <span>{{ instance.instanceName }}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="configsContainer progress-loader" *ngIf="isLoading">
          <mat-spinner [diameter]="30" class="mat-warn mat-hue-1 loaderIcon" *ngIf="isLoading">
          </mat-spinner>
        </div>
        <div class="configsContainer" *ngIf="!isLoading">
          <div *ngIf="selctedTestID && !isNewTestConfig">
            <h4 class="reflect-banner">
              <mat-icon class="material-icons mat-18">directions_run</mat-icon>
              <span class="banner-text"
                >Status
                <span *ngIf="formObj.instanceName">for {{ formObj.instanceName }}</span></span
              >
            </h4>
            <div
              class="reflect-status status related-content-group sub-content related-items-container-skin"
            >
              <div class="row session-info">
                <div flex="30" class="column" *ngIf="formObj.reflectorMode !== 'light'">
                  <label class="status-txt">Active Sessions</label>
                  <div class="centeralign">{{ activeSessions }}</div>
                </div>

                <div flex="30" class="column" *ngIf="formObj.reflectorMode !== 'light'">
                  <label class="status-txt">Active Flows</label>
                  <div class="centeralign">{{ activeFlows }}</div>
                </div>

                <div flex="30" class="column">
                  <label class="status-txt">Packets Reflected</label>
                  <div class="centeralign">{{ packetsReflected }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="right-content">
            <h4>
              <mat-icon class="material-icons mat-18">settings</mat-icon>
              <span class="banner-text"
                >Settings
                <span *ngIf="formObj.instanceName">for {{ formObj.instanceName }}</span></span
              >
            </h4>
            <mat-card>
              <div
                class="row start center reflect-banner"
                *ngIf="reflectorTypeValid() && reflectorVersionValid()"
              >
                <div class="control-group row">
                  <div class="column">
                    <label class="checkcontainer">
                      <input
                        type="checkbox"
                        [(ngModel)]="formObj.liteModeSelect"
                        (click)="checkModeType()"
                        [disabled]="!isEditable()"
                      />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                  <div class="column">
                    <label for="formObj.liteModeSelect">Use TWAMP Light</label>
                  </div>
                  <div class="ip-version">
                    <label for="ipVersion" class="reflect-version labelMode">IP Version</label>
                    <mat-select
                      name="ipVersion"
                      [(value)]="formObj.ipVersion"
                      class="input-decor input-mini"
                      [disabled]="!isNewTestConfig || !ipVersionEnabled || mgmtPortTesting"
                      (selectionChange)="onChangeVersion(formObj.ipVersion)"
                      matTooltip="This endpoint has management port testing enabled. IP version is set to the
                      version of the endpoint."
                      [matTooltipDisabled]="!mgmtPortTesting"
                    >
                      <mat-option value="v4">v4</mat-option>
                      <mat-option value="v6">v6</mat-option>
                    </mat-select>
                  </div>
                </div>
              </div>
              <div class="row row-item" *ngIf="isNewTestConfig">
                <div class="control-group span2-75">
                  <label class="labelMode"
                    >Reflector Name
                    <i class="fa fa-question-circle" title="Identify the test configs"> </i>
                  </label>
                  <input
                    matInput
                    autocomplete="off"
                    [(ngModel)]="formObj.instanceName"
                    name="instancename"
                    max="20"
                    class="control input-decor input-ipv4"
                    #instanceInput="ngModel"
                    [ngClass]="{ invalidInput: !testNameisValid && isNewTestConfig }"
                    (ngModelChange)="validateInstanceName()"
                    required
                  />
                  <div class="err-msgContainer">
                    <mat-error *ngIf="instanceInput?.errors?.required"> Required field</mat-error>
                    <mat-error *ngIf="instanceInput?.errors?.max">Maximum 20 charactors</mat-error>
                    <mat-error *ngIf="!testNameisValid && isNewTestConfig"
                      >Name has already been used</mat-error
                    >
                  </div>
                </div>
              </div>
              <div class="row row-item start center" *ngIf="'v6' !== formObj.ipVersion">
                <div class="control-group" flex="35">
                  <label class="labelMode">Address</label>
                  <input
                    matInput
                    autocomplete="off"
                    [(ngModel)]="formObj.ipAddress"
                    name="ip"
                    class="control input-decor input-ipv4"
                    [disabled]="!isEditable() || mgmtPortTesting"
                    required
                    #addressInput="ngModel"
                    [pattern]="ipv4Pattern"
                    [ngClass]="{
                      invalidInput: (isnotUniqueConfig || isnotUniqueIPConfig) && isNewTestConfig
                    }"
                    (blur)="isUniqueConfig()"
                    matTooltip="This endpoint has management port testing enabled. IP address is set to the
                    address of the endpoint."
                    [matTooltipDisabled]="!mgmtPortTesting"
                  />
                  <div *ngIf="isNewTestConfig" class="err-msgContainer">
                    <mat-error *ngIf="addressInput?.errors?.required"> Required field</mat-error>
                    <mat-error *ngIf="addressInput?.errors?.pattern">Invalid address</mat-error>
                    <mat-error *ngIf="isnotUniqueConfig || isnotUniqueIPConfig"
                      >Address in use by running reflector</mat-error
                    >
                  </div>
                </div>
                <div class="control-group" flex="32" *ngIf="!mgmtPortTesting">
                  <label class="labelMode">Subnet mask</label>
                  <input
                    matInput
                    autocomplete="off"
                    [(ngModel)]="formObj.subnet"
                    name="subnet"
                    class="control input-decor input-ipv4"
                    [disabled]="!isEditable()"
                    required
                    #subnetInput="ngModel"
                    [pattern]="ipv4SubnetPattern"
                  />
                  <div *ngIf="isNewTestConfig" class="err-msgContainer">
                    <mat-error *ngIf="subnetInput?.errors?.required"> Required field</mat-error>
                    <mat-error *ngIf="subnetInput.errors?.pattern"> Invalid subnet mask </mat-error>
                  </div>
                </div>
                <div class="control-group" flex="33" *ngIf="!mgmtPortTesting">
                  <label class="labelMode">Gateway</label>
                  <input
                    matInput
                    autocomplete="off"
                    [(ngModel)]="formObj.gateway"
                    name="gateway"
                    class="control input-decor input-ipv4"
                    [disabled]="!isEditable()"
                    #gatewayInput="ngModel"
                    required
                    [pattern]="ipv4Pattern"
                  />
                  <div *ngIf="isNewTestConfig" class="err-msgContainer">
                    <mat-error *ngIf="gatewayInput?.errors?.required"> Required field</mat-error>
                    <mat-error *ngIf="gatewayInput.errors?.pattern"> Invalid address </mat-error>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="formObj.ipVersion === 'v6'">
                <div class="control-group" flex="70">
                  <label class="labelMode">Address</label>
                  <input
                    [(ngModel)]="formObj.ipAddressV6"
                    name="ipV6"
                    class="control input-decor width-ipv6"
                    [ngClass]="{
                      invalidInput: (isnotUniqueConfig || isnotUniqueIPConfig) && isNewTestConfig
                    }"
                    [disabled]="!isEditable() || mgmtPortTesting"
                    (blur)="isUniqueConfig()"
                    required
                    #addressV6Input="ngModel"
                    [pattern]="ipv6Pattern"
                    matTooltip="This endpoint has management port testing enabled. IP address is set to the
                    address of the endpoint."
                    [matTooltipDisabled]="!mgmtPortTesting"
                  />
                  <div *ngIf="isNewTestConfig" class="err-msgContainer">
                    <mat-error *ngIf="addressV6Input?.errors?.required"> Required field</mat-error>
                    <mat-error *ngIf="addressV6Input?.errors?.pattern">Invalid address</mat-error>
                    <mat-error *ngIf="(isnotUniqueConfig || isnotUniqueIPConfig) && isNewTestConfig"
                      >Address in use by running reflector</mat-error
                    >
                  </div>
                </div>
                <div class="control-group" flex="28" *ngIf="!mgmtPortTesting">
                  <label class="labelMode">Subnet Prefix Length</label>
                  <input
                    [(ngModel)]="formObj.prefixV6"
                    name="prefixV6"
                    class="control input-decor input-small"
                    [disabled]="!isEditable()"
                    required
                    #subnetV6Input="ngModel"
                    [pattern]="ipv6PrefixLengthPattern"
                  />
                  <div *ngIf="isNewTestConfig" class="err-msgContainer">
                    <mat-error *ngIf="subnetV6Input?.errors?.required"> Required field</mat-error>
                    <mat-error *ngIf="subnetV6Input?.errors?.pattern"
                      >Invalid subnet prefix length</mat-error
                    >
                  </div>
                </div>
              </div>
              <div class="row start center" *ngIf="formObj.ipVersion === 'v6' && !mgmtPortTesting">
                <div class="control-group" flex="40">
                  <label class="labelMode">Gateway</label>
                  <input
                    [(ngModel)]="formObj.gatewayV6"
                    name="gatewayV6"
                    class="control input-decor width-ipv6"
                    [disabled]="!isEditable()"
                    required
                    #gatewayV6Input="ngModel"
                    [pattern]="ipv6Pattern"
                  />
                  <div *ngIf="isNewTestConfig" class="err-msgContainer">
                    <mat-error *ngIf="gatewayV6Input?.errors?.required"> Required field</mat-error>
                    <mat-error *ngIf="gatewayV6Input?.errors?.pattern">Invalid address</mat-error>
                  </div>
                </div>
              </div>

              <div class="row row-item start center" *ngIf="formObj.reflectorMode != 'full'">
                <div class="control-group" flex="35">
                  <label class="labelMode">UDP Port</label>
                  <input
                    [(ngModel)]="formObj.udpport"
                    name="udpport"
                    class="control input-decor input-ipv4"
                    [disabled]="!isEditable()"
                    required
                    #udpPortInput="ngModel"
                    (ngModelChange)="handleReflectorLightPortRange()"
                  />
                  <div *ngIf="isNewTestConfig" class="err-msgContainer">
                    <mat-error *ngIf="udpPortInput?.errors?.required"> Required field</mat-error>
                    <mat-error *ngIf="udpPortInput?.errors?.regex">1-65535 except 5060</mat-error>
                  </div>
                </div>
              </div>

              <div class="row row-item start start" *ngIf="formObj.reflectorMode != 'light'">
                <div class="control-group" flex="35">
                  <label class="labelMode">Control Port</label>
                  <input
                    [(ngModel)]="formObj.port"
                    name="port"
                    class="control input-decor input-ipv4"
                    [disabled]="!isEditable()"
                    required
                    #controlPortInput="ngModel"
                    [pattern]="controlPortPattern"
                  />
                  <div *ngIf="isNewTestConfig" class="err-msgContainer">
                    <mat-error *ngIf="controlPortInput?.errors?.required">
                      Required field</mat-error
                    >
                    <mat-error *ngIf="controlPortInput?.errors?.pattern"
                      >Range is 1-65535</mat-error
                    >
                  </div>
                </div>
                <div class="control-group" flex="32">
                  <label class="labelMode">Max Sessions</label>
                  <input
                    [(ngModel)]="formObj.maxSessions"
                    name="sessions"
                    class="control input-decor input-ipv4"
                    [disabled]="!isNewTestConfig || agentModel === 'QT600-10'"
                    required
                    #maxSessionInput="ngModel"
                    [pattern]="maxSessionsValidated"
                  />
                  <div *ngIf="isNewTestConfig" class="err-msgContainer">
                    <mat-error *ngIf="maxSessionInput?.errors?.required"> Required field</mat-error>
                    <mat-error *ngIf="maxSessionInput?.errors?.pattern">{{
                      sessionsConfig.maxRangeErr
                    }}</mat-error>
                  </div>
                </div>
                <div class="control-group" flex="33">
                  <label class="labelMode">Max Flows</label>
                  <input
                    [(ngModel)]="formObj.maxFlows"
                    name="flows"
                    class="control input-decor input-ipv4"
                    [disabled]="!isNewTestConfig || agentModel === 'QT600-10'"
                    required
                    #maxFlowsInput="ngModel"
                    [pattern]="maxFlowsValidated"
                  />
                  <div *ngIf="isNewTestConfig" class="err-msgContainer">
                    <mat-error *ngIf="maxFlowsInput?.errors?.required"> Required field</mat-error>
                    <mat-error *ngIf="maxFlowsInput?.errors?.pattern">{{
                      flowsConfig.maxRangeErr
                    }}</mat-error>
                  </div>
                </div>
              </div>
              <div class="row row-item" *ngIf="agentModel !== 'QT600-10'">
                <div class="control-group column" flex="35">
                  <label class="labelMode">VLAN Configuration</label>
                  <mat-select
                    [(value)]="formObj.vlanNumber"
                    class="input-decor input-medium"
                    [disabled]="!isNewTestConfig && (actionMsg || selctedTestID)"
                    (selectionChange)="isUniqueConfig()"
                  >
                    <mat-option value="untagged" selected>Untagged</mat-option>
                    <mat-option value="tagged">Single VLAN</mat-option>
                    <mat-option value="q_in_q">Q-In-Q</mat-option>
                  </mat-select>
                </div>

                <div class="control-group" flex="32" *ngIf="formObj.vlanNumber !== 'untagged'">
                  <label class="labelMode">{{
                    formObj.vlanNumber === 'q_in_q' ? 'S-VLAN ID' : 'VLAN ID'
                  }}</label>
                  <input
                    [(ngModel)]="formObj.sVlanId"
                    name="sVlanId"
                    class="input-decor input-ipv4"
                    type="text"
                    [pattern]="vLanPattern"
                    maxlength="4"
                    placeholder="1-4095"
                    #svlanInput="ngModel"
                    [ngClass]="{ invalidInput: isnotUniqueConfig && isNewTestConfig }"
                    [disabled]="!isNewTestConfig && (actionMsg || selctedTestID)"
                    [required]="formObj.vlanNumber !== 'untagged'"
                    (blur)="isUniqueConfig()"
                  />
                  <div
                    *ngIf="isNewTestConfig"
                    class="err-msgContainer"
                    [ngClass]="{ 'ext-height': isnotUniqueConfig && isNewTestConfig }"
                  >
                    <mat-error *ngIf="svlanInput?.errors?.required"> Required field</mat-error>
                    <mat-error *ngIf="svlanInput?.errors?.pattern">Range is 1-4095</mat-error>
                    <mat-error *ngIf="isnotUniqueConfig && isNewTestConfig"
                      >IP and VLAN in use by running reflector</mat-error
                    >
                  </div>
                </div>
                <div class="control-group" flex="33"></div>
              </div>

              <div
                class="row row-item"
                *ngIf="agentModel !== 'QT600-10' && formObj.vlanNumber === 'q_in_q'"
              >
                <div class="control-group column" flex="35">
                  <label class="labelMode">EtherType</label>
                  <mat-select
                    [(ngModel)]="formObj.etherType"
                    [(value)]="formObj.etherType"
                    class="input-decor input-medium"
                    [disabled]="!isNewTestConfig && (actionMsg || selctedTestID)"
                  >
                    <mat-option value="88a8">88a8</mat-option>
                    <mat-option value="8100">8100</mat-option>
                    <mat-option value="9100">9100</mat-option>
                  </mat-select>
                </div>

                <div class="control-group column" flex="35">
                  <label class="labelMode">C-VLAN ID</label>
                  <input
                    [(ngModel)]="formObj.cVlan"
                    name="cVlan"
                    class="input-decor input-ipv4"
                    type="text"
                    [pattern]="vLanPattern"
                    maxlength="4"
                    placeholder="0-4095"
                    #cvlanInput="ngModel"
                    [ngClass]="{ invalidInput: isnotUniqueConfig && isNewTestConfig }"
                    [disabled]="!isNewTestConfig && (actionMsg || selctedTestID)"
                    [required]="formObj.vlanNumber === 'q_in_q'"
                    (blur)="isUniqueConfig()"
                  />
                  <div *ngIf="isNewTestConfig" class="err-msgContainer">
                    <mat-error *ngIf="cvlanInput?.errors?.required"> Required field</mat-error>
                    <mat-error *ngIf="cvlanInput?.errors?.pattern">InvRange is 1-4095</mat-error>
                    <mat-error *ngIf="isnotUniqueConfig && isNewTestConfig"
                      >IP and VLAN in use by running reflector</mat-error
                    >
                  </div>
                </div>
              </div>
              <div class="row row-item" *ngIf="agentModel === 'QT600-10'">
                <div class="control-group" flex="35">
                  <div class="check-box-align">
                    <div class="column">
                      <label class="checkcontainer">
                        <input
                          type="checkbox"
                          name="enableVlan"
                          [(ngModel)]="formObj.enableVlan"
                          (ngModelChange)="isUniqueConfig()"
                          [disabled]="!isNewTestConfig && (actionMsg || selctedTestID)"
                        />
                        <span class="checkmark"></span>
                      </label>
                    </div>
                    <div class="column">
                      <label for="enableVlan">Enable VLAN</label>
                    </div>
                  </div>
                </div>
                <div class="control-group" flex="32" *ngIf="formObj.enableVlan">
                  <label class="labelMode">VLAN ID</label>
                  <input
                    [(ngModel)]="formObj.vlanId"
                    name="vlanId"
                    [required]="formObj.enableVlan"
                    class="control input-decor input-ipv4"
                    [disabled]="!isNewTestConfig && (actionMsg || selctedTestID)"
                    [pattern]="vLanPattern"
                    [ngClass]="{ invalidInput: isnotUniqueConfig && isNewTestConfig }"
                    (blur)="isUniqueConfig()"
                    #vlanidInput="ngModel"
                  />
                  <div *ngIf="isNewTestConfig" class="err-msgContainer">
                    <mat-error *ngIf="vlanidInput?.errors?.required"> Required field</mat-error>
                    <mat-error *ngIf="vlanidInput?.errors?.pattern"
                      >Maximum 20 charactors</mat-error
                    >
                    <mat-error
                      *ngIf="!vlanidInput?.errors?.required && isnotUniqueConfig && isNewTestConfig"
                      >IP and VLAN in use by running reflector</mat-error
                    >
                  </div>
                </div>
                <div class="control-group" flex="33"></div>
              </div>
              <div class="row row-item start start persist" *ngIf="isAllowPersist">
                <div class="control-group row" flex="40">
                  <div class="column">
                    <label class="checkcontainer">
                      <input
                        type="checkbox"
                        id="onBootPersist"
                        name="restartOnBoot"
                        #restartInput="ngModel"
                        [(ngModel)]="formObj.restartOnBoot"
                        [disabled]="!isNewTestConfig && (actionMsg || selctedTestID)"
                        class="ng-valid ng-dirty ng-valid-parse ng-touched ng-empty"
                        aria-invalid="false"
                      />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                  <div class="column">
                    <label for="restartOnBoot">Persist after Reboot</label>
                  </div>
                </div>
              </div>
            </mat-card>
          </div>

          <div class="row action-content">
            <button
              mat-raised-button
              color="primary"
              (click)="startEndpoint()"
              [disabled]="!form?.valid || isDiableBtn()"
              *ngIf="isNewTestConfig && !errorMsg && !actionMsg"
            >
              <mat-icon class="material-icons">play_arrow</mat-icon>Start Reflector
            </button>

            <button
              mat-raised-button
              color="warn"
              (click)="showRemoveDialog()"
              *ngIf="
                isNewTestConfig && selectedTestInfo?.status === 'idle' && !errorMsg && !actionMsg
              "
            >
              <mat-icon class="material-icons">delete</mat-icon>Remove Config
            </button>

            <button
              mat-raised-button
              color="warn"
              (click)="showStopDialog()"
              *ngIf="
                !isNewTestConfig &&
                !errorMsg &&
                !actionMsg &&
                selectedTestInfo?.status === 'running'
              "
            >
              <mat-icon class="material-icons">stop</mat-icon> Stop Reflector
            </button>

            <div class="row center twamp-reflect-action message" *ngIf="actionMsg || errorMsg">
              <mat-spinner
                [diameter]="30"
                class="twamp-reflect-progress mat-warn mat-hue-1"
                *ngIf="actionMsg"
              >
              </mat-spinner>
              <div class="action-msg" *ngIf="actionMsg">{{ actionMsg }}</div>
              <div
                *ngIf="errorMsg"
                class="row center twamp-error-msg"
                [color]="{
                  success: errorIcon !== 'warning',
                  warn: errorIcon === 'warning'
                }"
              >
                <mat-icon
                  class="material-icons"
                  [ngClass]="{
                    success: errorIcon !== 'warning',
                    warn: errorIcon === 'warning'
                  }"
                  >{{ errorIcon }}</mat-icon
                >
                <span class="error-msg">{{ errorMsg }}</span>
                <button
                  mat-raised-button
                  [color]="errorIcon === 'warning' ? 'warn' : 'primary'"
                  (click)="okClicked()"
                  *ngIf="errorMsg"
                >
                  ok
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
